import { GestorDocumentosFirma } from '../components/GestDocumentosFirma/GestorDocumentosFirma';
import Layout from "../components/Layout";

const GestorDocumentosFirmaCli = () => {
    return (
        <>
            <Layout />
            <div className="bg-slate-100 h-screen w-full overflow-y-auto">
                <GestorDocumentosFirma />
            </div>
        </>
    );
}

export default GestorDocumentosFirmaCli;
